module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Aussie Men Are "), _c('br'), _vm._v("the Pits")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-inspiration"
    }
  }, [_vm._v("The Inspiration")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#the-insulting-compliment"
    }
  }, [_vm._v("The Insulting Compliment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#older-man-crisis-1-the-married-oh-sh--what-did-i-do",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Older Man Crisis 1 The Married-Oh-Sh**- What-Did-I-Do")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#but-i-know-you-are-the-one-so-ill-just-keep-going-until-you-get-it",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("But I Know You Are the One So I’ll Just Keep Going Until You Get It")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#the-i-dont-know-how-to-say-hello-so-ill-cast-a-side-glance-from-the-bar-or-call-a-friend",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The I-Don’t-Know-How-To Say-Hello-So-I’ll-Cast-A-Side-Glance-From-The-Bar-Or-Call-A-Friend")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#and-then-the-world-threw-me-a-bone-and-god-laughed",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("And Then the World Threw Me A Bone and God Laughed")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#getting-over-the-pain-from-a-relationship",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting Over the Pain from a Relationship")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#men-with-pictures-in-their-heads",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Men with Pictures in Their Heads")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#the-im-not-ready-for-a-girlfriend-otherwise-called-the-i-want-you-only-when-you-dont-want-me",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The I’m-Not-Ready-For-A-Girlfriend, Otherwise Called the I-Want-You-Only-When-You-Don’t-Want-Me")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#the-wanna-be-serious",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wanna-Be-Serious")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#the-capital-c-confusion-or-capital-d-distraction",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Capital C Confusion or Capital D Distraction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#control-and-the-element-of-but-i-dont-have-any-anger",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Control and the Element of ‘But I Don’t Have Any Anger’")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#wanna-chat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wanna Chat?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#personality-baby-so-just-deal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Personality Baby So Just Deal")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#the-guy-who-doesnt-want-to-give-much-away",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Guy Who Doesn’t Want to Give Much Away")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#game-players",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Game-Players")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#slow-movers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slow-Movers")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#men-in-their-30-or-40-somethings-who-like-to-date-women-in-their-20-somethings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Men in Their 30 or 40-Somethings Who Like to Date Women in Their 20-Somethings")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#the-belief-in-the-ideal-female-men-who-are-looking-for-that-baggageless-30-year-old-female-with-no-attachments-to-a-career",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Belief in the Ideal Female (Men Who Are Looking for That Baggageless 30-Year-Old Female with No Attachments to a Career)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#the-i-can-try-but-you-have-to-say-no",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The I-Can-Try-But-You-Have-To-Say-No")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#the-non-pursuer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Non-Pursuer")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#flakes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flakes")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#older-man-crisis-2-no-woman-no-mortgage-niente-vs-the-bag-of-accidental-children",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Older Man Crisis 2: No Woman, No Mortgage, NIENTE Vs the Bag Of ‘Accidental’ Children")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#and-then-there-was-the-cold-shoulder",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("And Then There Was the Cold Shoulder")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#mummies-boys",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mummies’ Boys")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#peter-pan-syndrome",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peter Pan Syndrome")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#grumpy-old-men",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grumpy ‘Old’ Men")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#the-tradie-effect",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tradie Effect")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#the-ferrari",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ferrari")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#men-who-hold-the-hurt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Men Who Hold the Hurt")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#men-who-behave-as-women-and-then-have-a-problem-with-a-woman-who-behaves-like-a-man",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Men Who Behave as Women (And Then Have a Problem with a Woman Who Behaves Like a Man)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#you-remind-me-of-my-ex",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Remind Me of My Ex")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#the-super-intense",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Super-Intense")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#toning-it-down-so-you-want-it-morewhat-the",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toning It Down So You Want It More…What The…?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#guys-not-spending-the-effort-on-the-girlfriends",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guys Not Spending the Effort on the Girlfriends")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#guys-who-have-more-bathroom-products-than-the-girl-uh-oh",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guys Who Have More Bathroom Products than the Girl – Uh, Oh!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#takers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Takers")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#language-and-communication-language-like-magic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Language and Communication, Language Like Magic")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#interview-for-role-of-wife-when-just-thought-going-for-a-job",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interview for Role of Wife When Just Thought Going for a Job!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#vacillators",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vacillators")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#the-anti-suitors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Anti-Suitors")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#pictures-in-the-head-does-not-make-it-to-the-bed",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pictures in the Head Does Not Make It to the Bed")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch047#guys-who-cannot-be-friends",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guys Who Cannot Be Friends")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch048#the-guy-who-stands-you-up",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Guy Who Stands You Up")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-cat-like-proclivities-of-men",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cat-Like Proclivities of Men")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch050#the-completely-selfish",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Completely Selfish")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch051#man-with-child",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Man with Child")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch052#conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch053#for-the-boys",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For the Boys")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0